import React from 'react'
import { Link } from 'react-router-dom';
import './Nc.css';

function Eposy01() {
  return (
    <div className='container-fluid'>
      <div className="row ">
        <img src="./img/main10.jpg" className=' h_01 p-0' alt="" />
        {/* <p className='b_text text-light'>Welcome To Our World</p> */}
      </div>

      <div className='row mt-5'>
       <div className="col-sm-5 m-auto p-sm-5 p-md-2" >
        <h1 style={{ color:'#e0be94', textShadow:'3px 0 #16365E' }}><em>
  <span style={{ fontFamily: 'Georgia'}}>Classic </span>
</em> Epoxy Thinner</h1>
        <p style={{  color:'#16365E',textAlign: 'justify', textJustify: 'newspaper' }}>"<em>
  <span style={{ fontFamily: 'Georgia', fontSize: '30px' }}>Classic </span>
</em> Epoxy Thinner" stands out as a versatile solution, comprising a meticulous blend of hydrocarbons and organic solvents. This formulation finds extensive use in enhancing the viscosity of Epoxy Paints and primers, ensuring a desired consistency in applications. Notably, its exceptional property of rapid surface drying contributes to achieving a bubble-free, sag-free finish. Highly sought after in industries associated with floor coatings and swimming pools, the thinner provides a protective shield, imparting resistance against surface damage. With its ability to deliver quick results and maintain high demand, "Classic Epoxy Thinner" emerges as a reliable choice for achieving optimal performance in various coating applications.</p>
<Link to="/Contact" className='btn btn-primary mb-3'> Contact Us</Link>

       </div>
       <div className="col-sm-5 m-auto ">
       <img src="./img/Pro09.jpg" className='h_7 w-100 rounded rounded-5' alt="" />
       </div>
      </div>
      
      
    </div>
  )
}

export default Eposy01
